<mat-form-field>
  <mat-label>Tipo</mat-label>
  <mat-select placeholder="Tipo" [(ngModel)]="selectedInventoryActionType" (ngModelChange)="onTypeSelected()" required>
    @for(type of inventoryActionTypes; track type) {
      <mat-option [value]="type">{{type | human | titlecase}}</mat-option>
    }
  </mat-select>
</mat-form-field>

@if(!loading){
  @if (selectedInventoryActionType === 'InventoryAction::Consume') {
    <mat-card>
      <mat-card-header>
        <div mat-card-avatar><i class="fa fa-cog fa-2x"></i></div>
        <mat-card-title>Configuración General</mat-card-title>
        <mat-card-subtitle>Administre la configuración de {{ selectedInventoryActionType | human}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="row">
          <div class="col-full">
            <form [formGroup]="companyForm">
              <fieldset formGroupName="preferences">
                <fieldset formGroupName="inventory_action/consume">
                  <mat-form-field>
                    <mat-label>Estado de la orden donde iniciarán las labores de bodega (ej. búsqueda de los repuestos)</mat-label>
                    <mat-select
                        placeholder="Estados de la orden en el cual se iniciarán las labores de bodega (búsqueda de los repuestos)"
                        formControlName="start_status_ids"
                        multiple
                    >
                      <mat-optgroup label="{{ 'Order' | human }}">
                        @for(status of orderStatuses | async; track status.id) { 
                          <mat-option [value]="status.id">{{status.name}}</mat-option>
                        }
                      </mat-optgroup>
                      <mat-optgroup label="{{ 'Budget' | human }}">
                        @for(status of budgetStatuses | async; track status.id) { 
                          <mat-option [value]="status.id">{{status.name}}</mat-option>
                        }
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                  <mat-checkbox formControlName="automatic_consumption_completion">
                    Automáticamente finalizar los consumos
                  </mat-checkbox>
                  @if (companyForm.get('preferences.inventory_action/consume.automatic_consumption_completion').value) {
                    <mat-form-field>
                      <mat-label>Estado de la orden donde finalizarán las labores de bodega (ej. entrega de los repuestos)</mat-label>
                      <mat-select
                          placeholder="Estados de la orden donde finalizarán las labores de bodega (ej. entrega de los repuestos)"
                          formControlName="finish_status_ids"
                          multiple
                      >
                        <mat-optgroup label="{{ 'Order' | human }}">
                          @for(status of orderStatuses | async; track status.id) { 
                            <mat-option [value]="status.id">{{status.name}}</mat-option>
                          }
                        </mat-optgroup>
                        <mat-optgroup label="{{ 'Budget' | human }}">
                          @for(status of budgetStatuses | async; track status.id) { 
                            <mat-option [value]="status.id">{{status.name}}</mat-option>
                          }
                        </mat-optgroup>
                      </mat-select>
                    </mat-form-field>
                  }
                </fieldset>
              </fieldset>
            </form>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }


  <app-status-form
  [type]="'Status::' + selectedInventoryActionType"
  [showStatuses]="true"
  [showNotifyClient]="true"
  [showTransitions]="true"
  ></app-status-form>
  <app-work-form [model]="selectedInventoryActionType"></app-work-form>
  <app-admin-custom-fields [service]="fieldsService" model="Field::{{selectedInventoryActionType}}"></app-admin-custom-fields>
  <app-client-notification-form [model]="selectedInventoryActionType"></app-client-notification-form>
}